<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero title="Condoleances">
      <p
        v-if="listMixin.list.length === 0"
        class="page-hero-intro text-center"
      >
        Er zijn momenteel geen condoleances om weer te geven.
      </p>
      <div
        v-else
        class="text-center"
      >
        <p class="page-hero-intro">
          {{ listMixin.list.length }} {{ listMixin.list.length === 1 ? 'condoleance' : 'condoleances' }} ontvangen
        </p>
        <v-btn
          class="mt-2"
          color="secondary"
          rounded
          variant="outlined"
          @click="Export()"
        >
          <v-icon
            class="mr-2"
            size="18"
          >
            mdi-printer-outline
          </v-icon>
          Condoleances afdrukken
        </v-btn>
        <p class="page-hero-hint mt-2">
          Hiervoor heeft u Acrobat Reader nodig.
          U kan dit gratis <a class="secondaryLink" href="https://get.adobe.com/nl/reader/" target="_blank" rel="noopener noreferrer">downloaden</a>.
        </p>
      </div>
    </page-hero>

    <!-- Condolence list -->
    <v-form
      v-model="valid"
      ref="form"
    >
      <v-row justify="center">
        <v-col
          class="center"
          cols="12"
          md="8"
          lg="6"
        >
          <div class="condoleances-list">
            <div
              v-for="(item, index) in listMixin.list"
              class="condoleance-card"
              :key="index"
            >
              <!-- Main condolence message -->
              <div class="condoleance-message">
                <div class="condoleance-sender">
                  <v-icon
                    color="#907322"
                    size="18"
                  >
                    mdi-account-outline
                  </v-icon>
                  <span class="condoleance-sender-name">
                    {{ item.naam }}
                  </span>
                </div>
                <div class="condoleance-text">
                  {{ item.tekst }}
                </div>
                <v-btn
                  v-if="item.allowReply"
                  class="condoleance-reply-btn mt-3"
                  color="#907322"
                  size="small"
                  variant="text"
                  @click="CondoleanceReply(item)"
                >
                  <v-icon
                    class="mr-1"
                    size="16"
                  >
                    mdi-reply
                  </v-icon>
                  Beantwoorden
                </v-btn>
              </div>

              <!-- Replies -->
              <div
                v-for="(replyItem, index2) in item.antwoorden"
                class="condoleance-reply"
                :key="`${index}-reply-${index2}`"
              >
                <div class="condoleance-sender condoleance-sender--reply">
                  <v-icon
                    color="#424E58"
                    size="18"
                  >
                    mdi-reply
                  </v-icon>
                  <span class="condoleance-sender-name">
                    {{ replyItem.naam }}
                  </span>
                </div>
                <div class="condoleance-text">
                  {{ replyItem.tekst }}
                </div>
              </div>

              <!-- Reply form -->
              <div
                v-if="reply.item && reply.item.idDossierCondoleance === item.idDossierCondoleance"
                class="condoleance-reply-form"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="reply.familienaam"
                      base-color="primary"
                      bg-color="white"
                      color="primary"
                      density="compact"
                      label="Uw naam"
                      variant="outlined"
                      :rules="[validationMixin.rules.max50Characters, validationMixin.rules.required]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="reply.voornaam"
                      base-color="primary"
                      bg-color="white"
                      color="primary"
                      density="compact"
                      label="Uw voornaam"
                      variant="outlined"
                      :rules="[validationMixin.rules.max50Characters, validationMixin.rules.required]"
                    />
                  </v-col>
                </v-row>
                <v-textarea
                  v-model="reply.tekst"
                  auto-grow
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  label="Uw antwoord"
                  variant="outlined"
                  :rules="[validationMixin.rules.required]"
                />
                <div class="d-flex justify-end">
                  <v-btn
                    class="mr-2"
                    variant="text"
                    @click="CondoleanceReply(item)"
                  >
                    Annuleren
                  </v-btn>
                  <v-btn
                    color="primary"
                    rounded
                    @click="CondoleanceReplySend()"
                  >
                    <v-icon
                      class="mr-1"
                      size="18"
                    >
                      mdi-send
                    </v-icon>
                    Versturen
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import validationMixin from '@/mixins/validationMixin'
import blobMixin from '@/mixins/blobMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import listMixin from '@/mixins/listMixin'
import klantService from '@/services/klantService'
import rapportService from '@/services/rapportService'

export default {
  name: 'CondoleancesComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin,
    blobMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    listMixin,
    validationMixin
  ],
  data () {
    return {
      reply: {
        familienaam: null,
        isNew: true,
        item: null,
        tekst: null,
        voornaam: null
      },
      valid: false
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.raadplegen = true
    klantService.Init(this)
    rapportService.Init(this)
    this.GetUitvaartCondoleanceList()
  },
  beforeUnmount () {
    this.$store.state.headers.raadplegen = false
  },
  methods: {
    async CondoleanceReply (item) {
      this.reply.item = this.reply.item && this.reply.item.idDossierCondoleance === item.idDossierCondoleance ? null : item
      this.reply.familienaam = null
      this.reply.voornaam = null
      this.reply.tekst = null
    },
    async CondoleanceReplySend () {
      this.$refs.form.validate()

      if (this.valid) {
        this.CommonMixin_Load(this.$options.name, true)

        const resp = await klantService.SendUitvaartCondoleanceListAntwoord({
          ...this.reply,
          idDossierCondoleance: this.reply.item.idDossierCondoleance
        })

        if (resp && (resp.data || resp.data !== '')) {
          this.reply.item.antwoorden.push(resp.data)
          await this.CondoleanceReply(this.reply.item)
        }

        this.CommonMixin_Load(this.$options.name, false)
      }
    },
    async Export () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await rapportService.Download(this.constantMixin.rapporten.condoleances.id, this.constantMixin.guids.empty)

      if (resp && (resp.data || resp.data !== '')) {
        this.BlobMixin_DownloadApiGeneratedFile(resp)
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetUitvaartCondoleanceList () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartCondoleanceList()

      if (resp && (resp.data || resp.data !== '')) {
        this.listMixin.list = resp.data
      }

      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
/* Condolence list */
.condoleances-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 48px;
}

.condoleance-card {
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  padding: 24px;
  background-color: #fdfcfa;
}

.condoleance-sender {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.condoleance-sender-name {
  font-size: 16px;
  font-weight: 600;
  color: #907322;
}

.condoleance-sender--reply .condoleance-sender-name {
  color: #424E58;
  font-weight: 500;
}

.condoleance-text {
  font-size: 15px;
  line-height: 1.7;
  color: #424E58;
  white-space: pre-line;
}

.condoleance-reply-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
}

/* Replies */
.condoleance-reply {
  margin-top: 16px;
  margin-left: 24px;
  padding-top: 16px;
  padding-left: 20px;
  border-left: 2px solid #DEC067;
  border-top: 1px solid #f0ece4;
}

/* Reply form */
.condoleance-reply-form {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e4dc;
}
</style>
